import React, { useState } from 'react';
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Card,
} from '@material-ui/core';
import Modal from 'components/Modal';
import { PaginationNumbers, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { exportClassroomsStatement, getClasses } from '@webapps/business';
import { useStyles } from '@webapps/styles';
import { cx } from '@emotion/css';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';

const months = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

const stylesFn = ({ spacing, palette }) => ({
  formControl: {
    width: '100%',
  },
  content: {
    // padding: spacing(2),
    backgroundColor: "white"
  },
  studentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(2),
    justifyContent: 'space-between',
  },
  classroomItem: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: spacing(2),
    marginBottom: spacing(0),
    width: `calc(50% - ${spacing(1)}px)`,
    backgroundColor: "#F3F7FF",
    borderRadius: spacing(1),
    border: "1px solid transparent",
    alignItems: 'center',
  },
  selectedClassroom: {
    border: "1px solid #0060F9 !important",
  },
  classInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoContainer: {
    marginLeft: spacing(2),
  },
  periodSection: {
    marginTop: spacing(4),
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.25),
  },
  title: {
    paddingBottom: spacing(2),
  },
  checkboxContainer: {
    width: 20,
    height: 20,
    border: '1px solid #0060F9',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&.checked': {
      backgroundColor: '#0060F9',
    },
  },
  checkIcon: {
    color: 'white',
    fontSize: 16,
  },
});

const ExportModalContent = ({ onClose, idClass }) => {
  const { classes, global } = useStyles(stylesFn);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);
  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const itemsPerPage = 6;
  const { idUser } = useAuth();

  const handleClassToggle = (classId) => {
    setSelectedClasses((prev) =>
      prev.includes(classId)
        ? prev.filter((id) => id !== classId)
        : [...prev, classId]
    );
  };

  const { data: { content: classrooms = [], totalElements } = {}, refetch } =
    useQuery(getClasses, {
      key: ['classes export ', idUser],
      variables: {
        keyword: '',
        training: '',
        trainingType: '',
        degree: '',
        id: idUser,
        page: currentPage - 1,
        size: 100000, // LE JOUR OU ON CHANGE çA APPELEZ MOI (WASSIM)
      },
      keepPreviousData: true,
      staleTime: 5000,
    });

  const handlePageChange = (event) => {
    setCurrentPage(event);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedClasses = classrooms.slice(startIndex, endIndex);

  const handleExport = async () => {
    try {
      setLoading(true)
      
      if(idClass){
        selectedClasses.push(idClass);
      }

      const joinSelectedClasses = selectedClasses.join(",");
      
      const { data } = await exportClassroomsStatement.query({
        classroomIds: joinSelectedClasses,
        startDate: new Date(startYear, startMonth - 1, 1).toISOString().split("T")[0],
        endDate: new Date(endYear, endMonth, 0).toISOString().split("T")[0],
      });

      fetch(`${process.env.NX_PROXY_API}/export`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: data,
          includeAllStudents: false
        }),
      })
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = blob.type.includes('zip') ? 'export.zip' : 'export.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })


      if (onClose) onClose();

    } catch (error) {
      console.error('Error exporting statement:', error);
    } finally {
      setLoading(false)
    }
  };

  

  return (
    <div className={classes.content}>
      <Grid container spacing={2}>

        {!idClass && <Grid item xs={12}>
          <div className={cx(global.title, classes.title)}>
            Sélectionner les classes
          </div>
          <div className={classes.studentContainer}>
            {displayedClasses.map((classe) => (
              <div
                key={classe.id}
                className={`${classes.classroomItem} ${
                  selectedClasses.includes(classe.id) ? classes.selectedClassroom : ''
                }`}
                onClick={() => handleClassToggle(classe.id)}
              >
                <div className={classes.classInfo}>
                  <div className={classes.infoContainer}>
                    <div className={cx(global.title)}>
                      {classe.label}
                    </div>
                    <div className={cx(global.infoText)}>
                      {classe.school?.name || 'École non spécifiée'}
                    </div>
                  </div>
                </div>
                <div 
                  className={`${classes.checkboxContainer} ${selectedClasses.includes(classe.id) ? 'checked' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClassToggle(classe.id);
                  }}
                >
                  {selectedClasses.includes(classe.id) && (
                    <CheckIcon className={classes.checkIcon} />
                  )}
                </div>
              </div>
            ))}
          </div>
          <Box mt={2} display="flex" justifyContent="center">
            <PaginationNumbers
              page={currentPage}
              pageCount={itemsPerPage}
              totalCount={classrooms.length}
              onChange={handlePageChange}
            />
          </Box>
        </Grid>}

        <Grid item xs={12} className={classes.periodSection}>
          <div className={cx(global.title, classes.title)}>
            Période
          </div>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Date de début
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Mois</InputLabel>
                    <Select
                      value={startMonth}
                      onChange={(e) => setStartMonth(e.target.value)}
                    >
                      {months.map((month) => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Année</InputLabel>
                    <Select
                      value={startYear}
                      onChange={(e) => setStartYear(e.target.value)}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Date de fin
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Mois</InputLabel>
                    <Select
                      value={endMonth}
                      onChange={(e) => setEndMonth(e.target.value)}
                    >
                      {months.map((month) => (
                        <MenuItem key={month.value} value={month.value}>
                          {month.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Année</InputLabel>
                    <Select
                      value={endYear}
                      onChange={(e) => setEndYear(e.target.value)}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box mt={4} display="flex" justifyContent="center">
        <Button
          onClick={handleExport}
          color="primary"
          variant="contained"
          disabled={idClass ? loading : selectedClasses.length === 0 ? true : loading}
        >
          {loading ? 'Chargement...' : 'Exporter'}
        </Button>
      </Box>
    </div>
  );
};

const ExportModal = ({ open, onClose, classes, idClass }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Exporter les relevés"
      width={800}
      fullWidth
      styles={
        {
          padding: '20px 24px'
        }
      }
    >
      <ExportModalContent onClose={onClose} classes={classes} idClass={idClass} />
    </Modal>
  );
};

export default ExportModal;
